/* global location */
/* eslint no-restricted-globals: ["off", "location"] */
import React, { Component } from "react";
import { Search, Menu, Balloon } from "@alife/next";
import SpaceImageUpload from "@alife/image-ad-upload";
import goldlog from "@ali/goldlog";
import { connect } from "@alife/tarot";
import $ from "jquery";
import Util from "../../util/common";
import { renderDownLoadSvg, renderAppDownloadSvg } from "./downloadSvg";
import { getExpParams } from "../components/offerV3/utils";
import { getSuggestKeywordList } from "../../../service";
const { Item } = Menu;

class Header extends Component {
  constructor(opts) {
    super(opts);
    this.onChange = this.onChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
    // 添加防抖定时器
    this.debounceTimer = null;
    this.requestCounter = 0;
  }

  state = {
    keyword: "",
    overlayVisible: false,
    downloadIconHover: false,
    downloadAppHover: false,
    dataSource: [],
  };

  onSelect(keyword) {
    if (keyword) {
      this.setState({
        keyword: keyword[0],
        overlayVisible: false,
      });
    }
  }

  onInputBlur() {
    this.setState({
      overlayVisible: false,
    });
  }

  // eslint-disable-next-line react/sort-comp
  renderMenu() {
    const { dataSource, keyword } = this.state;
    const { width = 1190 } = this.props;
    let _w;
    if (width == 990) {
      _w = 296;
    } else if (width == 1190) {
      _w = 496;
    } else {
      _w = 704;
    }

    return (
      <Menu
        onSelect={this.onSelect.bind(this)}
        style={{ width: _w }}
        selectMode="single"
      >
        {dataSource.map((item) => {
          let queryWords = [];
          const arr = item.queryWords.split('');
          arr.forEach(item => {
            if (keyword.split('').includes(item)) {
               queryWords.push(<span className="red">{item}</span>)
            }else {
              queryWords.push(item)
            }
          })
          // const index = item.queryWords.indexOf(keyword);
          // if (index !== -1) {
          //   queryWords = [
          //     item.queryWords.substring(0, index), // 关键字前面的部分
          //     keyword, // 关键字本身
          //     item.queryWords.substring(index + keyword.length), // 关键字后面的部分
          //   ];
          // } else {
          //   queryWords = [item.queryWords];
          // }
          return (
            <Item key={item.queryWords} className="clearfix">
              {/* {queryWords[0]}
              <span className="red">{queryWords[1]}</span>
              {queryWords[2]} */}
              {queryWords}
            </Item>
          );
        })}
      </Menu>
    );
  }

  componentDidMount() {
    this.setState({
      keyword: pageConfig.keywords,
    });
    this.downloadGoldlog("pcsem-icon-download", "EXP");
    this.downloadGoldlog("pcsem-app-download", "EXP");
  }

  async onChange(value) {
    // 清除之前的定时器
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.setState({
      keyword: value,
    })
    // 设置新的防抖定时器，300ms 后执行
    this.debounceTimer = setTimeout(async () => {
      const currentRequestId = ++this.requestCounter;
      const data = await getSuggestKeywordList(value);
      if (currentRequestId === this.requestCounter) {
        this.setState({
          dataSource: data,
          overlayVisible: data.length > 0,
        });
      }
    }, 300);
  }

  onSearch() {
    const obj = Util.getUrlParms();
    let spm = "";
    let spmAB = "";
    if (window.goldlog && window.goldlog.spm_ab) {
      spmAB = window.goldlog.spm_ab.join(".");
    }
    spm = spmAB ? `${spmAB}.dh_004.submit` : "a312h.2018_new_sem.dh_004.submit";
    Object.assign(obj, {
      keywords: "",
      sortType: "",
      descendOrder: "",
      province: "",
      city: "",
      priceStart: "",
      priceEnd: "",
      dis: "",
      provinceValue: "所在地区",
      p_rs: true,
      exp: window.pageConfig.exp,
      ptid: (window.p4pObject && window.p4pObject.ptid) || "",
    });
    obj.keywords = this.state.keyword;
    obj.spm = spm;
    delete obj.hpageId;
    delete obj.a_o;
    delete obj.outerId;
    // obj._version ="v3";
    //const origin = Util.getLocationOrigin();

    //const _url = origin + location.pathname;
    // const _url = 'https://p4psearch.1688.com/p4p114/p4psearch/offer.htm';
    const _url = "https://1688.com/zw/page.html?hpageId=old-sem-pc-list";
    const path = $.param(obj);
    console.log(path);

    window.__WPO.log(`keywords_${this.state.keyword}`, 1);
    goldlog.record(
      "/szyx.pc_sem.keywords",
      "CLK",
      `keyword=${this.state.keyword}`,
      "GET"
    );
    window.location.href = `${_url}&${path}`;
  }

  downloadGoldlog(position, goKey) {
    if (goldlog && goldlog.record) {
      goldlog.record(
        "/ifission.ifission.miniod",
        goKey,
        `position=${position}`,
        "GET"
      );
    }
  }

  renderPlugIns() {
    return (
      <div className="plug-ins">
        <img src="https://img.alicdn.com/imgextra/i3/O1CN01O54Lc41GSSzPCp7Ah_!!6000000000621-2-tps-744-800.png" />
        <a
          className="plug-ins-btn"
          target="_blank"
          href="https://wxthirdplatform-p.1688.com/1688extension?source=1688.bizsearch.popover.default&target=landingPage
          "
          onClick={() =>
            this.downloadGoldlog("pcsem-icon-tooltip-download", "CLK")
          }
        >
          立即下载
        </a>
      </div>
    );
  }

  renderDownloadIcon = () => {
    return (
      <Balloon
        className="plugins-tooltip"
        align="b"
        closable={false}
        trigger={
          <a
            className="btn download"
            onMouseEnter={() => {
              // 每次Hover都报EXP
              this.downloadGoldlog("pcsem-icon-tooltip-download", "EXP");
              this.setState({ downloadIconHover: true });
            }}
            onMouseLeave={() => {
              this.setState({ downloadIconHover: false });
            }}
            target="_blank"
            href="https://wxthirdplatform-p.1688.com/1688extension?source=1688.bizsearch.icon.default&target=landingPage"
            onClick={() => this.downloadGoldlog("pcsem-icon-download", "CLK")}
          >
            {renderDownLoadSvg(
              this.state.downloadIconHover ? "#FF5B00" : "black"
            )}
            <span>下载插件</span>
          </a>
        }
      >
        {this.renderPlugIns()}
      </Balloon>
    );
  };

  renderAppDownloadIcon = () => {
    return (
      <Balloon
        className="plugins-tooltip"
        align="b"
        closable={false}
        trigger={
          <div
            className="btn download"
            onMouseEnter={() => {
              // 每次Hover都报EXP
              this.downloadGoldlog("pcsem-app-tooltip-download", "EXP");
              this.setState({ downloadAppHover: true });
            }}
            onMouseLeave={() => {
              this.setState({ downloadAppHover: false });
            }}
            onClick={() => this.downloadGoldlog("pcsem-app-download", "CLK")}
          >
            {renderAppDownloadSvg(
              this.state.downloadAppHover ? "#FF5B00" : "black"
            )}
            <span>下载APP</span>
          </div>
        }
      >
        <div className="plug-ins" style={{ paddingTop: "18px" }}>
          <div className="appQrcode" />
        </div>
      </Balloon>
    );
  };

  render() {
    const { width = 1190 } = this.props;
    let _w;
    if (width == 990) {
      _w = 300;
    } else if (width == 1190) {
      _w = 530;
    } else {
      _w = 850;
    }
    // 图搜参数
    const wholeHeight = 50;
    const theme = "p4pImage";
    const imgSearchUrlParam = {
      cosite: (window.p4pObject && window.p4pObject.cosite) || "",
      keywordid: (window.p4pObject && window.p4pObject.keywordid) || "",
      trackid: (window.p4pObject && window.p4pObject.trackid) || "",
      location: (window.p4pObject && window.p4pObject.location) || "",
      ptid: (window.p4pObject && window.p4pObject.ptid) || "",
      bd_vid: (window.p4pObject && window.p4pObject.bd_vid) || "",
    };
    const spm_ab =
      window.goldlog && window.goldlog.spm_ab
        ? window.goldlog.spm_ab.join(".")
        : "";
    const imgSearchSpm = spm_ab
      ? `${spm_ab}.dh_004.img_search`
      : "a312h.2018_new_sem.dh_004.img_search";
    const exp = window.pageConfig && window.pageConfig.exp;
    const expParams = getExpParams(exp);
    return (
      <div
        className="header1688_new clearfix"
        onClick={this.onInputBlur.bind(this)}
        data-spm="dh_004"
      >
        <div className={`w_${width} header`}>
          <a
            className="sw-logo"
            href="https://re.1688.com"
            target="_blank"
            rel="noreferrer"
          />
          <div style={{ width: `${_w}px`, position: "relative" }}>
            <Search
              className="line_block ver-mid mr60"
              autoWidth
              combox={<div>{this.renderMenu()}</div>}
              overlayVisible={this.state.overlayVisible}
              style={{ width: _w }}
              hasIcon={false}
              searchText="搜索"
              onChange={this.onChange.bind(this)}
              onSearch={this.onSearch.bind(this)}
              value={this.state.keyword}
            />
            <div className="img-upload" id="img-upload">
              <SpaceImageUpload
                width={wholeHeight * 0.53 + "px"}
                height={wholeHeight * 0.47 + "px"}
                theme={theme}
                urlParam={imgSearchUrlParam}
                spm={imgSearchSpm}
              />
            </div>
          </div>
          {expParams["pcSemDownloadPlugin"] === "B" ? (
            <div>
              {this.renderAppDownloadIcon()}
              {this.renderDownloadIcon()}
            </div>
          ) : (
            <div className="qrcode" />
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  ...state.header,
});
export default connect(mapStateToProps)(Header);
